(function() {
  'use strict';

  var popup = document.querySelector('[data-welcome-popup]');
  if (!popup) return;

  var STORAGE_KEY = 'cuento-popup-dismissed';

  if (localStorage.getItem(STORAGE_KEY)) return;

  var section = popup.closest('.shopify-section');
  var delay = 3000;

  if (section) {
    var delayAttr = section.querySelector('[data-delay]');
    if (delayAttr) {
      delay = parseInt(delayAttr.dataset.delay, 10) * 1000;
    }
  }

  function showPopup() {
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hidePopup() {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, 'true');
  }

  setTimeout(showPopup, delay);

  var closeButtons = popup.querySelectorAll('[data-popup-close]');
  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', hidePopup);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      hidePopup();
    }
  });

  var form = popup.querySelector('form');
  if (form) {
    form.addEventListener('submit', function() {
      localStorage.setItem(STORAGE_KEY, 'true');
    });
  }
})();
